import { render, staticRenderFns } from "./InputAudio.vue?vue&type=template&id=4bcff89d&"
import script from "./InputAudio.vue?vue&type=script&lang=js&"
export * from "./InputAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports